jQuery(document).ready(function($){
  const header = $('#primary-header');
  const menuWithChildren = $('.menu-item-has-children');
  const menuButton = $('#menu-open');
  const navWrapper = $('#primary-nav-wrapper');

  //Change the size of the menu on-scroll
  $(window).scroll(function(){
    toggleMenuSize();
  });


  //Closes the menu when something outside of the menu is clicked
  $(window).on('click',function(){
    if(('ontouchstart' in window)){
      if($(navWrapper).hasClass('mod--active')){
        $(navWrapper).removeClass('mod--active');
      }
    }
  });

  //Mobile handler for menu
  $(menuWithChildren).on('click',function(e){
    if(('ontouchstart' in window)){
      if($(this).find('.sub-menu').hasClass('mod--active')){
        hideSubMenu(this);
      }
      else{
        e.preventDefault();
        showSubMenu(this);
      }
    }
    e.stopPropagation();
  });


  //Mobile Handle for nav wrapper
  $(menuButton).on('click',function(e){
    e.preventDefault();
    if(('ontouchstart' in window)){
      if($(navWrapper).hasClass('mod--active')){
        $(navWrapper).removeClass('mod--active');
        $(header).removeClass('mod--menu-active');
      }
      else{
        $(navWrapper).addClass('mod--active');
        $(header).addClass('mod--menu-active');
      }
    }
    return false;
  });

  //Open the menu when the menu button is hovered
  $(menuWithChildren).on('hover',function(e){
    if(!('ontouchstart' in window)){
      if(e.target !== $(menuWithChildren)) toggleDropdown(this);
    }
  });

  /**
   * Toggles the visibility of a dropdown menu item
   * @param menu
   */
  function toggleDropdown(menu){
    if($(menu).find('.sub-menu').hasClass('mod--active')){
      hideSubMenu(menu);
    }
    else{
      showSubMenu(menu);
    }
  }

  /**
   * Displays a sub menu
   * @param menu
   */
  function showSubMenu(menu){
    $(menu).children('.sub-menu').addClass('mod--active');
  }

  /**
   * Hides a sub menu
   * @param menu
   */
  function hideSubMenu(menu){
    $(menu).children('.sub-menu').removeClass('mod--active');
  }


  /**
   * Handles menu size toggling
   */
  function toggleMenuSize(){
    if($(window).scrollTop() > 0){
      $(header).addClass('mod--scrolled-nav');
    }
    else{
      $(header).removeClass('mod--scrolled-nav');
    }
  }

});


// WEBPACK FOOTER //
// /Users/brockduncan/Sites/zonedcomfort/wp-content/mu-plugins/vendor/underpin/header-nav/assets/js/stickyMenu.js